import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { Eyebrow } from './Eyebrow';
interface ClientLogo {
  name: string;
  src: string;
}
const CLIENT_LOGOS: ClientLogo[] = [{
  name: 'TXD',
  src: 'https://cdn.magicpatterns.com/uploads/uYrxFvFEASDw2fg9v9tQjL/TXD-Logo-1.webp'
}, {
  name: 'Sunrise Door Trim',
  src: 'https://cdn.magicpatterns.com/uploads/uZFRa76qR359VyyuRQowLX/Sunrise-door-logo.png'
}, {
  name: 'Redline Pool Tile Restoration',
  src: 'https://cdn.magicpatterns.com/uploads/32nBsB7qz3MTUdrdMNrMkv/hanse-new-logo_redline_pool_tile-200.png'
}, {
  name: 'Goat Cooling and Heating',
  src: 'https://cdn.magicpatterns.com/uploads/27XWGvaVZh4tczFTxpYZUh/goat-cooling-heating-logo.png'
}, {
  name: 'Logistics Now LLC',
  src: 'https://cdn.magicpatterns.com/uploads/nTPdc2dEsf94Hnk4MbMvH7/Logisitcs-Now_LLC_Full_Logo.webp'
}, {
  name: 'Deep Clean',
  src: 'https://cdn.magicpatterns.com/uploads/h7Kb2cjozdG4DLwdLza2sH/Deep-Clean-Favicon.png'
}, {
  name: 'The Patio Cover Company',
  src: 'https://cdn.magicpatterns.com/uploads/bdbwRhKn2tL7wudgqmuetb/a0d9155a-0fbd-4680-849e-286b44dcee72.png'
}, {
  name: 'Sparkle Tech Screen Service',
  src: 'https://cdn.magicpatterns.com/uploads/3h9oUq7LV7cVvao8K2n4Cc/sparkle-tech-screen-service-logo.png'
}, {
  name: 'Drop Zone Cleanup Co.',
  src: 'https://cdn.magicpatterns.com/uploads/m5gRVZfZw9giSSAPNCQjgP/logo.webp'
}, {
  name: 'Allstar Home Solutions',
  src: 'https://cdn.magicpatterns.com/uploads/kU1PhYjz4151dMM3kXotN8/cropped-AllStar-White-Background.png'
}, {
  name: 'All Star',
  src: 'https://cdn.magicpatterns.com/uploads/44UHLTv9tQNZALxVDmUdX9/headerlogo.webp'
}, {
  name: 'Blue Cactus Power Washing',
  src: 'https://cdn.magicpatterns.com/uploads/rD9S2nSMXRWjfvs4psH55T/BlueCactus_Power_Washing_Logo_White.svg'
}, {
  name: 'Summer Breeze Junk Removal',
  src: 'https://cdn.magicpatterns.com/uploads/ttguZ5EcQrTsS4ra4Jrw6n/summer-breeze-logo.png'
}, {
  name: 'Potential Realized Training',
  src: 'https://cdn.magicpatterns.com/uploads/tSMxH4N581MxRkC55ymavA/ll.webp'
}, {
  name: 'Pure Pulse Club',
  src: 'https://cdn.magicpatterns.com/uploads/bBLarrbV4iHLk36Uw8DzzC/pure-pulse-logo.png'
}, {
  name: 'Slater Elite Performance',
  src: 'https://cdn.magicpatterns.com/uploads/bq1vaRYxfMzs5cPFPMoWMc/slater-elite.png'
}, {
  name: 'Cloverfield Coaching',
  src: 'https://cdn.magicpatterns.com/uploads/vMTftL6A31iJZEPPCvGBXA/Cloverfield-olive.png'
}, {
  name: 'Winther Wealth',
  src: 'https://cdn.magicpatterns.com/uploads/4ELAGHraiAzmTydsH2a9f4/tmp7r03_gc_.webp'
}, {
  name: 'BE Clinical',
  src: 'https://cdn.magicpatterns.com/uploads/fkQNCQdMsXiYFcGbPmEJBP/images.jpg'
}];
export function LogoCarousel() {
  const reducedMotion = useReducedMotion();
  const firstRow = CLIENT_LOGOS.slice(0, 7);
  const secondRow = CLIENT_LOGOS.slice(7);
  return <section className="w-full overflow-hidden bg-[#111415] py-20 text-white lg:py-28" style={{
    backgroundImage: "radial-gradient(ellipse 62% 120% at 50% 48%, rgba(21, 47, 74, 0.9) 0%, rgba(15, 28, 41, 0.72) 46%, rgba(17, 20, 21, 0.2) 100%), url('https://cdn.magicpatterns.com/uploads/scC5pVG3EUePxKUfSG2TRr/Screenshot_2026-07-23_at_10.49.48_AM.png')",
    backgroundSize: 'cover',
    backgroundPosition: 'center'
  }} data-id="element-119" data-mp="3gv7asgg5x8he">
      <div className="mx-auto max-w-7xl px-6 lg:px-10" data-id="element-120" data-mp="3c4lezowev202">
        <motion.div initial={reducedMotion ? false : {
        opacity: 0,
        y: 16
      }} whileInView={reducedMotion ? undefined : {
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.4
      }} className="flex flex-col gap-5 sm:flex-row sm:items-end sm:justify-between" data-id="element-121" data-mp="3773f0o0dfx47">
          <div data-id="element-122" data-mp="3pycmkrql0bt5">
            <Eyebrow data-id="element-123" data-mp="3pxujpc9eyzc9">// The companies we grow</Eyebrow>
            <h2 className="mt-5 max-w-3xl font-display text-5xl uppercase leading-[0.95] sm:text-6xl" data-id="element-124" data-mp="3pz4gzz8g03hu">
              Built with businesses<br data-id="element-125" data-mp="3r4pecptfb87" />that show up.
            </h2>
          </div>
          <p className="max-w-xs text-sm leading-relaxed text-white/55 sm:pb-1" data-id="element-126" data-mp="3sz9xpx6d1br">
            From local service companies to teams built to scale, every logo represents work in progress.
          </p>
        </motion.div>
      </div>

      <div className="relative mt-14 space-y-4 before:pointer-events-none before:absolute before:inset-y-0 before:left-0 before:z-10 before:w-12 before:bg-gradient-to-r before:from-[#111415] before:to-transparent after:pointer-events-none after:absolute after:inset-y-0 after:right-0 after:z-10 after:w-12 after:bg-gradient-to-l after:from-[#111415] after:to-transparent sm:before:w-24 sm:after:w-24" data-id="element-127" data-mp="26zoglvts3n9i">
        <LogoTrack logos={firstRow} duration={34} direction="left" reducedMotion={reducedMotion} data-id="element-128" data-mp="1o96vacb9zty6" />
        <LogoTrack logos={secondRow} duration={27} direction="right" reducedMotion={reducedMotion} data-id="element-129" data-mp="1t89vnjgb9bzt" />
      </div>
    </section>;
}
interface LogoTrackProps {
  logos: ClientLogo[];
  duration: number;
  direction: 'left' | 'right';
  reducedMotion: boolean | null;
}
function LogoTrack({
  logos,
  duration,
  direction,
  reducedMotion
}: LogoTrackProps) {
  const trackLogos = Array.from({
    length: 4
  }, () => logos).flat();
  const initialX = direction === 'left' ? '0%' : '-25%';
  const animateX = direction === 'left' ? '-25%' : '0%';
  return <div className="flex overflow-hidden" aria-label="Businesses we work with" data-id="element-130" data-mp="j98mew1al52w">
      <motion.div className="flex min-w-max gap-4 pr-4 sm:gap-5 sm:pr-5" initial={{
      x: initialX
    }} animate={reducedMotion ? undefined : {
      x: animateX
    }} transition={reducedMotion ? undefined : {
      ease: 'linear',
      duration,
      repeat: Infinity,
      repeatType: 'loop'
    }} data-id="element-131" data-mp="ebyxrilq8xg4">
        {trackLogos.map((logo, index) => <div key={`${logo.name}-${index}`} className="flex h-20 w-36 shrink-0 items-center justify-center px-3 py-2 sm:h-24 sm:w-44" aria-hidden={index >= logos.length} data-id="element-132" data-mp="bo3e5l7l0q7" data-mpi={index}>
            <img src={logo.src} alt={index < logos.length ? logo.name : ''} loading="lazy" className="max-h-full max-w-full object-contain" data-id="element-133" data-mp="1pqci4dh9uure" />
          </div>)}
      </motion.div>
    </div>;
}